import type { ICardProps, IOmit } from '@sixui/ui';
import { Card, CardContent, CardMedia, CardTitle } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

export type IAppSettingCardProps = IOmit<ICardProps, 'children'> & {
  title: React.ReactNode;
  supportingText?: string;
  icon: React.ReactNode;
};

const styles = stylex.create({
  media: {
    height: 120,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    color: colorSchemeTokens.primary,
  },
  media$withIcon: {
    fontSize: 40,
  },
});

export const AppSettingCard: React.FC<IAppSettingCardProps> = (props) => {
  const { title, supportingText, icon, disabled, href, ...other } = props;

  return (
    <Card
      {...other}
      disabled={disabled}
      href={disabled ? undefined : href}
      variant="outlined"
    >
      <CardMedia sx={[styles.media, !!icon && styles.media$withIcon]}>
        {icon}
      </CardMedia>
      <CardContent>
        <CardTitle headline={title} supportingText={supportingText} />
      </CardContent>
    </Card>
  );
};
